// getters.js

export default {
    getAllDevices(state){
        return state.allDevices
    },
    getDevicesList(state){
        return state.devicesList
    },
    getDeviceTypeList(state){
        return state.deviceTypeList
    },
    getCurrentDevice(state){
        return state.currentDevice
    },
    getCurrentDeviceType(state){
        return state.currentDeviceType
    },
    getIsShowHeaderDeviceFilter(state){
        return state.showHeaderDeviceFilter
    }
};
